export const LANG = process.env.NEXT_PUBLIC_LOCALE
export const HOSTNAME = process.env.NEXT_PUBLIC_PROJECT_HOSTNAME
// export const CLIENT_NAME = process.env.NEXT_PUBLIC_CLIENT_NAME
export const DY_COOKIE_SESSION = 'DY_USER_VIRBAC_ES'
export const DY_COOKIE_DOMAIN = HOSTNAME

// Environment
export const DEV = process.env.NEXT_PUBLIC_VERCEL_ENV === 'development'
export const STAGING = process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview'
export const PRO = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'

export * from './httpCodes'
export * from './shuffle'
export * from './slugify'
export * from './icons'
export * from './sortBy'
export * from './cookie'
export * from './inputAutoComplete'
export * from './inputValidations'
export * from './inputPostalCodeValidations'
export * from './inputPatterns'
export * from './virbac'
export * from './blob_downloader'
export * from './copy_clipboard'
export * from './parsers'
